import {
  NotificationVariants,
  abbreviateId,
  logger,
  request,
  useCallbackRef,
  useEndpointsContext,
  useGlobalDialog,
  useGlobalToasts,
} from '@talos/kyoko';

interface CustomerTradeWithID {
  TradeID?: string | null;
}

export function useCustomerTradeCancellation() {
  const { orgApiEndpoint } = useEndpointsContext();
  const { add: addToast } = useGlobalToasts();
  const { open } = useGlobalDialog();

  const openCustomerTradeCancellation = useCallbackRef((trade: CustomerTradeWithID) => {
    const tradeID = trade.TradeID;
    if (tradeID == null) {
      logger.error(new Error('TradeID is null'), {
        extra: { trade },
      });
      return;
    }

    open({
      title: 'Cancel Customer Trade',
      content: `Are you sure you want to cancel customer trade #${abbreviateId(tradeID)}?`,
      onConfirm: () => {
        request('DELETE', `${orgApiEndpoint}/customer/trades/${tradeID}`)
          .then(() => {
            addToast({
              text: `Trade ${abbreviateId(tradeID)} cancelled.`,
              variant: NotificationVariants.Positive,
            });
          })
          .catch((e: ErrorEvent) =>
            addToast({
              text: `Could not cancel trade: ${e.message}`,
              variant: NotificationVariants.Negative,
            })
          );
      },
    });
  });

  return { openCustomerTradeCancellation };
}
